export default {
  slices: [
    {
      field: 'ad_categories',
      display: 'Event',
      map: {
        superbowl: {
          display: 'Super Bowl LV',
          sortOrder: 1
        },
        superbowl_56: {
          display: 'Super Bowl LVI',
          sortOrder: 2
        },
        superbowl_57: {
          display: 'Super Bowl LVII',
          sortOrder: 3
        },
        superbowl_58: {
          display: 'Super Bowl LVIII',
          sortOrder: 4
        },
        superbowl_59:{
          display: 'Super Bowl LIX',
          sortOrder: 5
        },
        superbowl_60:{
          display: 'Super Bowl LX',
          sortOrder: 6
        }
      }
    },
    {
      field: 'ad_type',
      display: 'Media Type',
      map: {
        tv: {
          display: 'TV',
          mediaType: 'mp4',
          sortOrder: 1
        }
      }
    },
  ]
}



// WEBPACK FOOTER //
// ./src/app/configuration/CategoryTentpoleEvents/config/metadata.js